import { Viewer, ImagePanorama } from "panolens";
import { useEffect, useRef, useState } from 'react';
import '../assets/css/views.css';

const Views = () => {
    const panoramaRef = useRef(null);
    const viewerRef = useRef(null);
    // const [currentPanorama, setCurrentPanorama] = useState(null);
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        if (!panoramaRef.current) return;

        // Create initial panorama
        const initialPanorama = new ImagePanorama("/hdri/tirupati/15.jpg");

        const viewer = new Viewer({
            container: panoramaRef.current,
            autoRotate: true, // Enable auto-rotation,
            controlBar: false,
            autoRotateSpeed: "1"
        });

        viewer.add(initialPanorama);
        viewerRef.current = viewer;
        // setCurrentPanorama(initialPanorama);

        return () => {
            viewer.dispose(); // Cleanup on unmount
        };
    }, []);

    const handleSetHdri = (path, index) => {
        setCurrentImage(index);
        if (!viewerRef.current) return;

        const newPanorama = new ImagePanorama(path);
        viewerRef.current.add(newPanorama);
        viewerRef.current.setPanorama(newPanorama); // Switch panorama

        // Remove the previous panorama to free up memory
        // if (currentPanorama) {
        //     viewerRef.current.remove(currentPanorama);
        // }

        // setCurrentPanorama(newPanorama);
    };

    return (
        <div>
            <div
                ref={panoramaRef}
                style={{ width: "100vw", height: "100vh", background: "#000" }}
            />
            <div className="floor_buttons">
                <ul>
                    <li>
                        <button onClick={() => handleSetHdri('/hdri/tirupati/15.jpg', 0)} className={`${currentImage === 0 ? 'active' : ''}`}>
                            15th Floor
                        </button>
                    </li>
                    <li>
                        <button onClick={() => handleSetHdri('/hdri/tirupati/25.jpg', 1)} className={`${currentImage === 1 ? 'active' : ''}`}>
                            25th Floor
                        </button>
                    </li>
                    <li>
                        <button onClick={() => handleSetHdri('/hdri/tirupati/35.jpg', 2)} className={`${currentImage === 2 ? 'active' : ''}`}>
                            35th Floor
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Views;
